module.exports = __webpack_public_path__ + "static/media/wip.f2769b43.png";